export default "__VITE_ASSET__BhsxsSK8__"